import { Injectable } from "@angular/core";
import { Http, Response, Headers, RequestOptions } from "@angular/http";
import { Observable } from "rxjs/Observable";

import { environment } from "../../environments/environment";
import { ProgramAreaSearchResult } from "@models/common";
import { StateMapRequest, StateMapResponse, AreaMapRequest, AreaMapResponse, PovertyMapRequest, RaceEthnicityMapRequest, MapResponseWithData, EducationalAttainmentMapRequest, EmploymentMapRequest, HousingMapRequest } from "@models/map";

@Injectable()
export class MapService {
    public shapeUrl: string = environment.apiUrl + "Shapes/";
    public apiUrl: string = environment.apiUrl;
    private headers = new Headers({ "Content-Type": "application/json", "Accept": "application/json;charset=UTF-8" });


    constructor(private http: Http) { }

    getShapes(type: number): Observable<string> {
        return this.http.get(this.shapeUrl + type)
            .map((response: Response) => <string>response.json())
            .catch(this.handleError);
    }

    // TODO: Remove Generate From Here
    generateShapes(type): Observable<void> {
        return this.http.post(this.shapeUrl + type, undefined)
            .map((response: Response) => <void>undefined)
            .catch(this.handleError);
    }

    searchProgramsAndAreas(query: any): Observable<ProgramAreaSearchResult[]> {
        return this.http.post(this.apiUrl + "Map/" + "Search", JSON.stringify(query), { headers: this.headers })
            .map((response: Response) => <ProgramAreaSearchResult[]>response.json())
            .catch(this.handleError);
    }

    filterStateMap(model: StateMapRequest): Observable<StateMapResponse> {
        return this.http.post(this.apiUrl + "Map/State/", JSON.stringify(model), { headers: this.headers })
            .map((response: Response) => <StateMapResponse>response.json())
            .catch(this.handleError);
    }

    filterPovertyMap(model: PovertyMapRequest): Observable<MapResponseWithData> {
        return this.http.post(this.apiUrl + "Map/Poverty/", JSON.stringify(model), { headers: this.headers })
            .map((response: Response) => <MapResponseWithData>response.json())
            .catch(this.handleError);
    }

    filterRaceEthnicityMap(model: RaceEthnicityMapRequest): Observable<MapResponseWithData> {
        return this.http.post(this.apiUrl + "Map/Race/", JSON.stringify(model), { headers: this.headers })
            .map((response: Response) => <MapResponseWithData>response.json())
            .catch(this.handleError);
    }

    filterEducationalAttainmentMap(model: EducationalAttainmentMapRequest): Observable<MapResponseWithData> {
        return this.http.post(this.apiUrl + "Map/Education/", JSON.stringify(model), { headers: this.headers })
            .map((response: Response) => <MapResponseWithData>response.json())
            .catch(this.handleError);
    }

    filterEmploymentMap(model: EmploymentMapRequest): Observable<MapResponseWithData> {
        return this.http.post(this.apiUrl + "Map/Employment/", JSON.stringify(model), { headers: this.headers })
            .map((response: Response) => <MapResponseWithData>response.json())
            .catch(this.handleError);
    }

    filterHousingMap(model: HousingMapRequest): Observable<MapResponseWithData> {
        return this.http.post(this.apiUrl + "Map/Housing/", JSON.stringify(model), { headers: this.headers })
            .map((response: Response) => <MapResponseWithData>response.json())
            .catch(this.handleError);
    }

    filterAreaMap(model: AreaMapRequest): Observable<AreaMapResponse> {
        return this.http.post(this.apiUrl + "Map/Area/", JSON.stringify(model), { headers: this.headers })
            .map((response: Response) => <AreaMapResponse>response.json())
            .catch(this.handleError);
    }

    private handleError(error: Response) {
        console.error(error);
        return Observable.throw(error.json() || "Server Error");
    }
}



// WEBPACK FOOTER //
// C:/WORK/Projects/ActNow_NG2/src/app/map/map.service.ts